export default userFields => field => {
  const value = userFields[field.name];
  return typeof value !== 'undefined' ? { ...field, value } : field;
};
